// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calc_price_class_booking_row *[data-v-644b3347]{margin-bottom:.25rem}", ""]);
// Exports
module.exports = exports;
